import { styled } from '@mui/material/styles'
import Scan from '@rfh/ui/shared/icons/Scan'

export const OrangeScanIcon = styled(Scan)(({ theme }) => ({
  color: `${theme.rfhColors.dutchOrange} !important`,
  fontSize: '1.5rem !important',
}))
